import React from 'react';
import './empty-test-agent-view.scss';
import { PNGS, SVGS } from '../../assets';
import { useEmptyTestAgentView } from './hooks/use-empty-test-agent-view';

interface EmptyTestAgentViewProps {
  setMsgText: (val: string) => void;
}

export const EmptyTestAgentView: React.FC<EmptyTestAgentViewProps> = ({
  setMsgText,
}) => {
  const { sampleQuestions } = useEmptyTestAgentView();

  return (
    <div className="empty-test-agent-view">
      <div className="empty-test-agent-view-container">
        <img src={PNGS.MonitorImage} alt="" width={122} height={122} />
        <div className="empty-test-agent-view-text">
          <span className="empty-test-agent-view-text-heading primary-font-bold">
            Test ZoAI agent
          </span>
          <span className="empty-test-agent-view-text-description primary-font-regular">
            This is a sample WhatsApp screen. Click and send any of the
            following questions to see how the AI agent will respond to your
            customers.
          </span>
        </div>
        <div className="empty-test-agent-view-questions">
          {sampleQuestions?.slice(0, 2).map((question, index) => {
            return (
              <div
                className={`agent-sample-question ${
                  index % 2 === 0 ? 'highlight-question' : ''
                }`}
                onClick={() => {
                  setMsgText(question);
                }}
              >
                <span className="agent-sample-question-text primary-font-regular">
                  {question}
                </span>
                <SVGS.SendOutlinedIconComponent
                  width={20}
                  height={20}
                  color={index % 2 === 0 ? '#ffffff' : '#262626'}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
